import React from 'react';

const TemplateFallbackTabContent = ({ tabName, tabLabel }) => (
    <div
        style={{
            width: '100%',
            height: '100%',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
        }}
    >
        {tabName} {tabLabel}
    </div>
);

export default TemplateFallbackTabContent;
